import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { stack as Menu } from 'react-burger-menu';
import classNames from 'classnames/bind';
import { getLinkTag, trackEvent, windowExists } from '../../utils';
import Accordion from '../Accordion';
import Button from '../Button';

import styles from './navigation.module.scss';

const cx = classNames.bind(styles);

class MobileNavigation extends React.Component {
  render() {
    return (
      <StaticQuery
        query={navigationQuery}
        render={(data) => {
          const { menuItems, cta, userAreaUrl } = data.contentfulNavigation;

          if (!windowExists) {
            return;
          }

          const location = `${window.location.pathname}${window.location.hash}`;

          return (
            <Menu {...this.props} noOverlay>
              {menuItems.map((item) => {
                if (item.subMenu) {
                  return (
                    <div className="menu-item" key={item.id}>
                      <Accordion variant="menu">
                        <Accordion.Item key={item.id} title={item.label}>
                          {item.subMenu.map((subItem) => {
                            const linkInformation = getLinkTag(subItem.pathname);
                            const Tag = linkInformation.tag;
                            const { tagProps } = linkInformation;

                            const tagClassName = cx({
                              mobileSubItem: true,
                              mobileSubItemActive: location.indexOf(subItem.pathname) >= 0,
                            });

                            if (linkInformation.isExternalLink) {
                              tagProps.gtmEventName = 'Navigation';
                              tagProps.label = subItem.label;
                            } else {
                              tagProps.onClick = function () {
                                trackEvent('Navigation', subItem.label);
                              };
                            }

                            return (
                              <Tag
                                key={subItem.id}
                                {...tagProps}
                                className={tagClassName}
                              >
                                {subItem.label}
                              </Tag>
                            );
                          })}
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  );
                }
                const linkInformation = getLinkTag(item.pathname);
                const Tag = linkInformation.tag;
                const { tagProps } = linkInformation;
                const tagClassName = cx({
                  mobileItem: true,
                  mobileItemActive: location.indexOf(item.pathname) >= 0,
                });

                if (linkInformation.isExternalLink) {
                  tagProps.gtmEventName = 'Navigation';
                  tagProps.label = item.label;
                } else {
                  tagProps.onClick = function () {
                    trackEvent('Navigation', item.label);
                  };
                }

                return (
                  <Tag
                    key={item.id}
                    {...tagProps}
                    className={tagClassName}
                  >
                    {item.label}
                  </Tag>
                );
              })}

              {cta && (
                <Button
                  link={cta.url}
                  variant="primary"
                  isFull
                  modifierclass={styles.mobileBtn}
                  {...cta}
                >
                  {cta.label}
                </Button>
              )}

              {userAreaUrl && (
                <Button
                  link={userAreaUrl}
                  variant="secondary"
                  isFull
                  modifierclass={styles.accountMobile}
                  {...cta}
                >
                  My account
                </Button>
              )}
            </Menu>
          );
        }}
      />
    );
  }
}

export default MobileNavigation;

const navigationQuery = graphql`
    query MobileNavigationQuery {
        contentfulNavigation(id:{eq:"f7c2f78a-81aa-5f51-9b1a-76d3a47b1565"}) {
            id,
            menuItems{
                id,
                label,
                pathname,
                subMenu{
                    id,
                    label,
                    pathname
                }
            },
            cta{
                label,
                url,
                istargetblank,
                gtmEventName,
                gtmEventType
            },
            userAreaUrl
        }
    }
`;
